import { GetterTree, MutationTree, ActionTree, ActionContext } from 'vuex';
import { HotelDetailsML, Order, User } from 'types';
import { HotelService, OrderService } from 'api';

export class State {
  orderV2: Order.Ml.Response.OrderDetails = null;
  productDetails: HotelDetailsML.Details = null;
  isLoading: boolean = true;
  error: string = '';

  isCancellationModalShown: boolean = false;
  cancellationError: string = '';
  isCancellationLoading: boolean = false;

  isCancellationSuccessShown: boolean = false;
}

const getters = <GetterTree<State, any>>{};

const mutations = <MutationTree<State>>{
  setOrderV2(state: State, order: State['orderV2']) {
    state.orderV2 = order;
  },
  setProductDetails(state: State, details: State['productDetails']) {
    state.productDetails = details;
  },
  setLoading(state: State, isLoading: boolean) {
    state.isLoading = isLoading;
  },
  setError(state: State, error: string) {
    state.error = error;
  },
  setOrderStatus(state: State, status: Order.Ml.OrderStatus) {
    if (state.orderV2) {
      state.orderV2.status = status;
    }
  },
  setCancellationError(state: State, error: string) {
    state.cancellationError = error;
  },
  setCancellationLoading(state: State, isLoading: boolean) {
    state.isCancellationLoading = isLoading;
  },
  toggleCancelModal(state: State, isShown: boolean) {
    state.isCancellationModalShown = isShown;
    if (!isShown) {
      state.cancellationError = '';
      state.isCancellationLoading = false;
    }
  },
  setCancellationSuccessShown(state: State, isShown: boolean) {
    state.isCancellationSuccessShown = isShown;
  },
};
const actions = <ActionTree<State, any>>{
  async getOrder(store: ActionContext<State, any>, orderID: string) {
    try {
      const order = await OrderService.ML.getOrderV2(orderID).toPromise();
      if (!order) {
        throw Error('Something went wrong.');
      }

      store.commit('setOrderV2', order);

      if (order.orderType === Order.Ml.OrderProductType.Hotel) {
        const hotelDetail = await HotelService.searchV2GetHotel(
          order.hotelLabel,
        ).toPromise();
        store.commit('setProductDetails', hotelDetail);
      }
    } catch (err) {
      console.log(err);
      store.commit('setError', err?.message ?? 'Unknown error');
    } finally {
      store.commit('setLoading', false);
    }
    // OrderService.getOrder(orderID).subscribe(
    //   res => {
    //     const order = { ...res };
    //     if (
    //       res.price_details &&
    //       res.price_details?.public_price <= res.price_details?.finalprice
    //     ) {
    //       order.price_details.public_price =
    //         res.price_details.finalprice + res.price_details.cashback;
    //     }
    //     store.commit('setOrder', order);
    //     store.commit('setLoading', false);

    //     const user: User.UserV2 = store.rootState.user.userV2;

    //     if (
    //       res.thrred_url &&
    //       user &&
    //       user.userId &&
    //       user.userId === res.user_id
    //     ) {
    //       store.dispatch(
    //         'booking/onDeferredOrderPayment',
    //         {
    //           orderId: res.order_id,
    //           thrredUrl: res.thrred_url,
    //           source: Order.PendingOrderSource.Order,
    //         },
    //         {
    //           root: true,
    //         },
    //       );
    //     }
    //   },
    //   err => {
    //     store.commit('setError', err.message);
    //     store.commit('setLoading', false);
    //   },
    // );
  },
  cancelOrder(store: ActionContext<State, any>) {
    store.commit('setCancellationError', '');
    store.commit('setCancellationLoading', true);
    OrderService.ML.cancelOrderV2(store.state.orderV2.id).subscribe(
      async res => {
        store.commit('setCancellationLoading', false);
        store.commit('toggleCancelModal', false);
        store.commit('setOrderStatus', Order.Ml.OrderStatus.ToCancel);
        store.commit('setCancellationSuccessShown', true);
      },
      err => {
        store.commit('setCancellationError', err.message);
        store.commit('setCancellationLoading', false);
      },
    );
  },
  setOrderStatus(
    store: ActionContext<State, any>,
    status: Order.Ml.OrderStatus,
  ) {
    store.commit('setOrderStatus', status);
  },
};

export const order = {
  namespaced: true,
  state: new State(),
  getters,
  mutations,
  actions,
};

export default {};
